const ModalMaisoku = {
  namespaced: true,
  state: {
    modal: false,
    list: [],
  },
  getters: {
    getModal: state => {
      return state.modal
    },
    getList: state => {
      return state.list
    },
  },
  mutations: {
    setModal(state, modal) {
      state.modal = modal
    },
    setList(state, list) {
      state.list = list
    },
  },
  actions: {
    set({ commit }, list) {
      commit('setList', list)
      commit('setModal', true)
    },
    reset({ commit }) {
      commit('setList', [])
      commit('setModal', false)
    },
  },
}

export default ModalMaisoku
